import script from "./PieChart2.vue?vue&type=script&setup=true&lang=js"
export * from "./PieChart2.vue?vue&type=script&setup=true&lang=js"

import "./PieChart2.vue?vue&type=style&index=0&id=3a383cd6&lang=less"

const __exports__ = script;

export default __exports__